import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { LoginForm } from './forms'
import { customizeError } from './customErrors'
import LandingPage from './LandingPage'
import WeaverService from 'Services/WeaverService'

Login = () ->

  [error, setError] = useState(undefined)
  [authenticated, setAuthenticated] = useState(false)
  [buttonText, setButtonText] = useState('Sign In')
  [loading, setLoading] = useState(false)
  [buttonEnabled, setButtonEnabled] = useState(false)
  [selfSignUpEnabled, setSelfSignUpEnabled] = useState(false)

  history = useHistory()

  useEffect( ->
    ( ->
      setSelfSignUpEnabled(await Weaver.getInstance().isSelfSignupEnabled())
    )()
    undefined
  , [])

  onChange = (e) ->
    setButtonEnabled(username.value isnt '' and password.value isnt '')

  onFinish = (values) ->
    setLoading(true)
    oldButtonText = buttonText
    setButtonText(' ')
    try
      response = await WeaverService.login(values.username, values.password)
      setAuthenticated(response?)
      setError(!response?)
      history.push('/')
    catch e
      err = customizeError(e)
      setError(err.message)
      setLoading(false)
      setButtonText(oldButtonText)
      throw e

  <LandingPage error={error}>
    <LoginForm
      onFinish={onFinish}
      onChange={onChange}
      buttonEnabled={buttonEnabled}
      loading={loading}
      buttonText={buttonText}
      selfSignUpEnabled={selfSignUpEnabled}
    />
  </LandingPage>

export default Login
